<template>
  <div>
    <div id="result"></div>
  </div>
</template>

<script>
import XLSX from "js-xlsx";
import axios from "axios";

export default {
  data() {
    return {};
  },
  components: {},
  mounted() {
    const { url } = this.$route.query;
    if (url) {
      this.previewExcel(url);
    }
  },
  computed: {},
  methods: {
    readWorkbook(workbook) {
      var sheetNames = workbook.SheetNames; // 工作表名称集合
      var worksheet = workbook.Sheets[sheetNames[0]]; // 这里我们只读取第一张sheet
      var csv = XLSX.utils.sheet_to_csv(worksheet);
      document.getElementById("result").innerHTML = this.csv2table(csv);
    },
    csv2table(csv) {
      var html = "<table>";
      var rows = csv.split("\n");
      rows.pop(); // 最后一行没用的
      rows.forEach(function(row, idx) {
        var columns = row.split(",");
        columns.unshift(idx + 1); // 添加行索引
        if (idx == 0) {
          // 添加列索引
          html += "<tr>";
          for (var i = 0; i < columns.length; i++) {
            html +=
              "<th>" +
              (i == 0 ? "" : String.fromCharCode(65 + i - 1)) +
              "</th>";
          }
          html += "</tr>";
        }
        html += "<tr>";
        columns.forEach(function(column) {
          html += "<td>" + column + "</td>";
        });
        html += "</tr>";
      });
      html += "</table>";
      return html;
    },
    previewExcel(url) {
      axios({
        url,
        method: "GET",
        responseType: "arraybuffer"
      }).then(res => {
        var data = new Uint8Array(res.data);
        var workbook = XLSX.read(data, { type: "array" });
        this.readWorkbook(workbook);
      });
    }
  }
};
</script>

<style lang='less' scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";
</style>